(function () {
  'use strict';

  /* @ngdoc object
   * @name help
   * @requires $stateProvider
   *
   * @description
   *
   */
  angular
    .module('Help', [
    ]);

  angular
    .module('Help')
    .config(config);

  function config() {
  }

})();
